import { axiosGet, axiosPost } from "../react_axios/Axios"
import { fillListUrl, platform, FILL_LIST_ACTION_TYPE, headers } from "../utils/constants"

export const fill_action = (actionID, exhibitionID, moduleID, keyValue, value, from) => async (dispatch) => {

  try {
    const mapdata = {
      ActionID: actionID,
      ExhibitionID: exhibitionID != '' ? exhibitionID : sessionStorage.getItem("sessionExhibitionID"),
      ModuleID: moduleID,
      KeyValue: keyValue,
      Value: value,
      ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS") != null ? sessionStorage.getItem("ExhRegistrationIDSS") : from
    }
    // console.log('mapdata', mapdata)
    const res = await axiosGet(fillListUrl, mapdata);

    dispatch({
      type: FILL_LIST_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

// same as fill_action, but the caller's exhRegistrationID is authoritative.
// fill_action reads ExhRegistrationIDSS from sessionStorage first, which is
// wrong on admin screens: that key is set by visa_invitation / manual form
// summary and is never cleared, so a stale registration would override the
// company the admin actually picked. Use this wherever the id comes from a
// dropdown rather than from the logged-in user's own session.
export const fill_scoped_action = (actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) => async (dispatch) => {

  try {
    const mapdata = {
      ActionID: actionID,
      ExhibitionID: exhibitionID != '' ? exhibitionID : sessionStorage.getItem("sessionExhibitionID"),
      ModuleID: moduleID,
      KeyValue: keyValue,
      Value: value,
      ExhRegistrationID: exhRegistrationID
    }
    const res = await axiosGet(fillListUrl, mapdata);

    dispatch({
      type: FILL_LIST_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const fill_master_action = (actionID, exhibitionID,moduleID,keyValue,value) => async (dispatch) => {

  try {
    const mapdata = {
      ActionID: actionID,
      ExhibitionID: exhibitionID,
      ModuleID: moduleID,
      KeyValue: keyValue,
      Value: value,
      ExhRegistrationID : sessionStorage.getItem("sessionExhRegistrationID")
    }
    console.log('mapdata', mapdata)
    const res = await axiosGet(fillListUrl, mapdata);

    dispatch({
      type: FILL_LIST_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};



